// // src/pages/AdminSlots.jsx
// import React, { useEffect, useState } from "react";
// import { ref, onValue, push, set, update } from "firebase/database";
// import { db } from "../firebase";

// export default function AdminSlots() {
//   const [title, setTitle] = useState("");
//   const [startsAt, setStartsAt] = useState(""); // optional
//   const [endsAt, setEndsAt] = useState("");     // optional
//   const [slots, setSlots] = useState([]);
//   const [active, setActive] = useState("");

//   useEffect(() => {
//     const off1 = onValue(ref(db, "slots"), (s) => {
//       const v = s.val() || {};
//       const arr = Object.keys(v).map(id => ({ id, ...v[id] })).sort((a,b)=> (a.createdAt||0)-(b.createdAt||0));
//       setSlots(arr);
//     });
//     const off2 = onValue(ref(db, "config/activeSlotId"), (s) => setActive(s.val() || ""));
//     return () => { off1(); off2(); };
//   }, []);

//   async function addSlot() {
//     if (!title.trim()) { alert("Enter a slot title"); return; }
//     const idRef = push(ref(db, "slots"));
//     await set(idRef, {
//       title: title.trim(),
//       startsAt: startsAt || null,
//       endsAt: endsAt || null,
//       createdAt: Date.now()
//     });
//     setTitle(""); setStartsAt(""); setEndsAt("");
//   }

//   async function setActiveSlot(id) {
//     await set(ref(db, "config/activeSlotId"), id);
//   }

//   return (
//     <div className="space-y-6">
//       <h1 className="text-2xl md:text-3xl font-bold">Admin — Slots</h1>

//       <div className="bg-white rounded-2xl shadow p-6 space-y-4">
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
//           <input className="p-3 border rounded-xl" placeholder="Slot Title (e.g., Day1-Morning)" value={title} onChange={(e)=>setTitle(e.target.value)} />
//           <input className="p-3 border rounded-xl" type="datetime-local" value={startsAt} onChange={(e)=>setStartsAt(e.target.value)} />
//           <input className="p-3 border rounded-xl" type="datetime-local" value={endsAt} onChange={(e)=>setEndsAt(e.target.value)} />
//           <button onClick={addSlot} className="px-4 py-3 rounded-xl bg-black text-white hover:opacity-90">Add Slot</button>
//         </div>

//         <div className="overflow-x-auto">
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="text-left border-b">
//                 <th className="py-2 pr-4">Title</th>
//                 <th className="py-2 pr-4">Start</th>
//                 <th className="py-2 pr-4">End</th>
//                 <th className="py-2 pr-4">Active</th>
//                 <th className="py-2 pr-4">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {slots.map(s => (
//                 <tr key={s.id} className="border-b hover:bg-gray-50">
//                   <td className="py-2 pr-4">{s.title}</td>
//                   <td className="py-2 pr-4">{s.startsAt || "-"}</td>
//                   <td className="py-2 pr-4">{s.endsAt || "-"}</td>
//                   <td className="py-2 pr-4">{active === s.id ? "✅" : ""}</td>
//                   <td className="py-2 pr-4">
//                     <button onClick={() => setActiveSlot(s.id)} className="px-3 py-1 rounded-lg border hover:bg-gray-50">
//                       Set Active
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//               {slots.length === 0 && <tr><td colSpan="5" className="py-4 text-gray-500">No slots yet.</td></tr>}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }



// src/pages/AdminSlots.jsx
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { ref, push, onValue, update, remove } from "firebase/database";

export default function AdminSlots() {
  const [name, setName] = useState("");
  const [start, setStart] = useState(""); // ISO datetime-local
  const [end, setEnd] = useState("");
  const [slots, setSlots] = useState([]);

  useEffect(() => {
    const off = onValue(ref(db, "slots"), (snap) => {
      const v = snap.val() || {};
      const rows = Object.entries(v).map(([id, s]) => ({ id, ...s }));
      rows.sort((a, b) => (a.st - b.st));
      setSlots(rows);
    });
    return () => off();
  }, []);

  async function addSlot() {
    if (!name || !start || !end) { alert("Fill all."); return; }
    const st = new Date(start).getTime();
    const et = new Date(end).getTime();
    if (et <= st) { alert("End must be after start."); return; }
    await push(ref(db, "slots"), { n: name, st, et, a: false }); // n=name, st=start, et=end, a=isActive
    setName(""); setStart(""); setEnd("");
  }

  async function toggleActive(id, curr) {
    await update(ref(db, `slots/${id}`), { a: !curr });
  }

  async function del(id) {
    if (window.confirm("Delete slot?")) await remove(ref(db, `slots/${id}`));
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl md:text-3xl font-bold">Admin — Slots</h1>

      <div className="bg-white rounded-2xl shadow p-6 space-y-3">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <input className="p-3 border rounded-xl" placeholder="Slot name" value={name} onChange={e=>setName(e.target.value)} />
          <input className="p-3 border rounded-xl" type="datetime-local" value={start} onChange={e=>setStart(e.target.value)} />
          <input className="p-3 border rounded-xl" type="datetime-local" value={end} onChange={e=>setEnd(e.target.value)} />
          <button onClick={addSlot} className="px-4 py-3 rounded-xl bg-black text-white hover:opacity-90">Add Slot</button>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left border-b">
                <th className="py-2 pr-4">Name</th>
                <th className="py-2 pr-4">Start</th>
                <th className="py-2 pr-4">End</th>
                <th className="py-2 pr-4">Active</th>
                <th className="py-2 pr-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {slots.map(s => (
                <tr key={s.id} className="border-b">
                  <td className="py-2 pr-4">{s.n}</td>
                  <td className="py-2 pr-4">{new Date(s.st).toLocaleString()}</td>
                  <td className="py-2 pr-4">{new Date(s.et).toLocaleString()}</td>
                  <td className="py-2 pr-4">
                    <span className={`px-2 py-1 rounded ${s.a ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}`}>
                      {s.a ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td className="py-2 pr-4 flex gap-2">
                    <button onClick={()=>toggleActive(s.id, s.a)} className="px-3 py-1 rounded-lg border hover:bg-gray-50">{s.a ? "Deactivate" : "Activate"}</button>
                    <button onClick={()=>del(s.id)} className="px-3 py-1 rounded-lg border text-red-600 hover:bg-red-50">Delete</button>
                  </td>
                </tr>
              ))}
              {slots.length === 0 && <tr><td colSpan="5" className="py-4 text-gray-500">No slots added.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

